import { useRef, useState } from "react"
import { Modal, Select, TableCustom } from "../../../../../components/common"
import { useEffect } from "react"
import {TIPS} from "../../../../../consts/tips";

const AddModal = ({ colecciones, tableData, show, onCancel, onAccept }) => {
    const [coleccionIndex, setColeccionIndex] = useState(-1)
    const [currentCampos, setCurrentCampos] = useState([])

    const tableRef = useRef(null)

    useEffect(() => {
        if (coleccionIndex === -1 || colecciones[coleccionIndex] === undefined)
            setCurrentCampos([])
        else {
            const excludeIds = tableData.map(x => x.idColeccionCampo)
            const campos = colecciones[coleccionIndex].coleccionesCampo.filter(({ id }) => !excludeIds.includes(id))
            setCurrentCampos(campos.map(item => ({
                ...item,
                selected: false,
            })))
        }
    }, [coleccionIndex, colecciones])

    const onColeccionChange = (id) => {
        setColeccionIndex(id)
        tableRef.current.manualReset()
    }

    const onItemsSelected = (items) => {
        const newCampos = [...currentCampos]
        items.forEach(item => {
            for (let i = 0; i < newCampos.length; i++) {
                if (newCampos[i].id === item.id) {
                    newCampos[i].selected = item.selected
                    break
                }
            }
        })
        setCurrentCampos(newCampos)
    }

    return <Modal
        onEscape={onCancel}
        show={show}
        title='Colección'
        tipName={TIPS.NAME.MODALS.COLECCION_MODAL}
        header={<div/>}
        body={(
            <div>
                <div className='row form-basic'>
                    <div className="col-12">
                        <label htmlFor="coleccion" className="form-label">Colección</label>
                        <Select
                            name='coleccion'
                            className="form-control"
                            value={coleccionIndex}
                            onChange={({ target }) => onColeccionChange(target.value)}
                            emptyOption="Sin selección"
                            emptyValue={-1}
                            options={colecciones.map((item, index) => ({value: index, label: item.nombre}))}
                        />
                    </div>
                    <TableCustom
                        className={'TableCustomBase'}
                        data={currentCampos}
                        columns={[
                            { Header: 'Código', accessor: 'codigo', width: '45%', },
                            { Header: 'Nombre', accessor: 'nombre', width: '45%', },
                        ]}
                        ref={tableRef}
                        onItemsSelected={onItemsSelected}
                        useSelectedField={true}
                        showDownloadCSV={false}
                        showFilterGlobal={true}
                        pageSize={50}
                    />
                </div>
            </div>
        )}
        footer={<>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onCancel}>Cancelar</button>
            <button
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={() => onAccept(currentCampos.filter(x => x.selected))}
                >Aceptar</button>
            
        </>}
    />
}

export default AddModal
